<div class="content">
  @if (loadedCourseContent) {
    <h1 [innerHTML]="loadedCourseContent.title"> </h1>
    @if (showVideo) {
      <app-video-player [video]="loadedCourseContent.videoCode" />
    }
    <div
      class="description"
      [innerHTML]="loadedCourseContent.description"
    ></div>
    @if (!showVideo && loadedCourseContent.linksList?.length) {
      <ul class="links-list">
        @for (link of loadedCourseContent.linksList; track $index) {
          <li>
            <mat-icon>link</mat-icon>
            @if (link.url.includes('http')) {
              <a
                href="{{ link.url }}"
                [target]="
                  link.target.toLowerCase() === 'new' ? '_blank' : '_self'
                "
              >
                {{ link.name }}
              </a>
            } @else {
              <a routerLink="{{ link.url }}">{{ link.name }}</a>
            }
          </li>
        }
      </ul>
    }
  }
</div>
